import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  availableStatuses: null,
  registryRights: [],
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "index", name: "global:complaint.index" },
      { key: "contractor.name", name: "global:complaint.contractor.name" },
      { key: "subjectOfTheComplaint", name: "global:complaint.subjectOfTheComplaint" },
      { key: "user.name, user.lastname", name: "global:complaint.userNameLastName" },
      { key: "status.name", name: "global:complaint.status" },
    ],
    selectedSearchFields: ["index"],
    dictionaryFields: ["complaintType", "detectedInTime"],
    url: "complaint",
  },
};

const complaintReducer = createSlice({
  name: "complaintReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = complaintReducer.actions;

export default complaintReducer.reducer;
